import { render, staticRenderFns } from "./FairConfig.vue?vue&type=template&id=c47bad30&scoped=true&"
import script from "./FairConfig.vue?vue&type=script&lang=js&"
export * from "./FairConfig.vue?vue&type=script&lang=js&"
import style0 from "./FairConfig.vue?vue&type=style&index=0&id=c47bad30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47bad30",
  null
  
)

export default component.exports